var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShifts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "24px",
    viewBox: "0 0 25 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "a-time") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shifts-NextGen-POS",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shifts-Menu-Login",
    transform: "translate(-40.000000, -441.000000)",
    fill: "#6F6F6F",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shifts-Group-6",
    transform: "translate(-1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shifts-Text-Labels",
    transform: "translate(1.000000, 270.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shifts-Icon-&-Text-Label-Copy-2"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.934641, 171.236607)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shifts-list",
    transform: "translate(0.065359, 0.286458)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shifts-a-time"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.375,10.42 L9.375,10.42 C6.49895833,10.42 4.16666667,7.60746833 4.16666667,5.21 L4.16666667,4.34166667 C4.16666667,1.94419833 6.49895833,0 9.375,0 L9.375,0 C12.2510417,0 14.5833333,1.94419833 14.5833333,4.34166667 L14.5833333,5.21 C14.5833333,7.60746833 12.2510417,10.42 9.375,10.42 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75,23.25 C22.2020833,23.25 25,20.5360208 25,17.1875 C25,13.8389792 22.2020833,11.125 18.75,11.125 C15.2979167,11.125 12.5,13.8389792 12.5,17.1875 C12.5,20.5360208 15.2979167,23.25 18.75,23.25 Z M17.7083333,13.1458333 L19.7916667,13.1458333 L19.7916667,16.1770833 L22.9166667,16.1770833 L22.9166667,18.1979167 L17.7083333,18.1979167 L17.7083333,13.1458333 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4166667,17.1875 C10.4166667,15.7577604 10.803125,14.4179479 11.4739583,13.2529375 C10.8,13.1852396 10.0979167,13.1458333 9.375,13.1458333 C6.43333333,13.1458333 3.82395833,13.7904792 2.11041667,14.3512604 C0.84375,14.7665417 0,15.9234687 0,17.2198333 L0,21.2291667 L11.540625,21.2291667 C10.8302083,20.0388958 10.4166667,18.6616979 10.4166667,17.1875 Z",
    id: "Path"
  })))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShifts);
export default __webpack_public_path__ + "static/media/Shifts.c6e26df1.svg";
export { ForwardRef as ReactComponent };